import React from 'react'

export const LockIcon = (color = '#495863', width = 18, height = 23) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.225 8.1V6C12.225 5.43333 12.075 4.9 11.775 4.4C11.4917 3.9 11.1 3.50833 10.6 3.225C10.1 2.925 9.56667 2.775 9 2.775C8.43333 2.775 7.9 2.925 7.4 3.225C6.9 3.50833 6.5 3.9 6.2 4.4C5.91667 4.9 5.775 5.43333 5.775 6V8.1H12.225ZM9 17.475C9.56667 17.475 10.0583 17.2667 10.475 16.85C10.8917 16.4333 11.1 15.9417 11.1 15.375C11.1 14.8083 10.8917 14.3167 10.475 13.9C10.0583 13.4833 9.56667 13.275 9 13.275C8.43333 13.275 7.94167 13.4833 7.525 13.9C7.10833 14.3167 6.9 14.8083 6.9 15.375C6.9 15.9417 7.10833 16.4333 7.525 16.85C7.94167 17.2667 8.43333 17.475 9 17.475ZM15.25 8.1C15.8167 8.1 16.3083 8.3 16.725 8.7C17.1417 9.1 17.35 9.58333 17.35 10.15V20.6C17.35 21.1667 17.1417 21.65 16.725 22.05C16.3083 22.45 15.8167 22.65 15.25 22.65H2.75C2.18333 22.65 1.69167 22.45 1.275 22.05C0.858334 21.65 0.65 21.1667 0.65 20.6V10.15C0.65 9.58333 0.858334 9.1 1.275 8.7C1.69167 8.3 2.18333 8.1 2.75 8.1H3.775V6C3.775 5.05 4.00833 4.175 4.475 3.375C4.94167 2.575 5.575 1.94167 6.375 1.475C7.175 1.00833 8.05 0.775 9 0.775C9.95 0.775 10.825 1.00833 11.625 1.475C12.425 1.94167 13.0583 2.575 13.525 3.375C13.9917 4.175 14.225 5.05 14.225 6V8.1H15.25Z"
        fill={color}
      />
    </svg>
  )
}
